const lib = {};

lib.get = function (url, data, loading) {
    return lib.ajax(url, 'GET', data, loading);
};

lib.post = function (url, data, loading) {
    return lib.ajax(url, 'POST', data, loading);
};

lib.postJSON = function (url, data, loading) {
    return lib.ajax(url, 'POST', typeof data === 'object' ? JSON.stringify(data) : data, loading, false, 'application/json; charset=UTF-8');
};

lib.getJSON = function (url, data, loading) {
    return lib.ajax(url, 'GET', typeof data === 'object' ? JSON.stringify(data) : data, loading, false, 'application/json; charset=UTF-8');
};

lib.ajax = function (url, type, data, loading, traditional = true, contentType = 'application/x-www-form-urlencoded; charset=UTF-8') {
    if (!loading) {
        loading = {val: false};
    }

    loading.val = true;

    const r = $.ajax({
        data: data,
        url: url,
        type: type,
        dataType: contentType.includes('json') ? 'json' : null,
        contentType: contentType,
        traditional: traditional,
    }).always(() => {
        loading.val = false;
    });

    const promise = new Promise((resolve, reject) => {
        r.then(
            (res, textStatus, jqXHR) => {
                const contentType = jqXHR.getResponseHeader("Content-Type");
                if (jqXHR.status === 200 && contentType.toLowerCase().indexOf("text/html") >= 0) {
                    window.location.reload();
                } else {
                    resolve(res);
                }
            },
            (jqXHR, state) => {
                if (jqXHR) {
                    const status = jqXHR.status;

                    if (status === 200 || status === 302 || status === 401) {
                        window.location.reload();
                    } else if (status !== 409 && state !== 'abort') {
                        reject(jqXHR, state)
                    }
                } else {
                    window.location.replace(jqXHR.url)
                }
            }
        )
    });

    // done/fail/always for backward compatibility
    promise.done = (callback) => {
        r.done((res) => callback(res));
        return promise;
    };

    promise.fail = (callback) => {
        r.fail((jqXHR, state) => {
            if (jqXHR.status === 409 || jqXHR.status === 500 || jqXHR.status === 400) {
                callback(jqXHR, state)
            }
        });
        return promise;
    };

    promise.always = (callback) => {
        r.always(() => callback());
        return promise;
    };

    promise.request = () => r;

    promise.r = r;

    return promise;
};

export default lib;